import variables from './variables'

export default {
  colors: {
    buttons: {
      primaryBackground: variables.colors.principalToolkitOrange,
      secondaryText: variables.colors.principalToolkitOrange,
      secondaryOutline: variables.colors.principalToolkitOrange,
    },
  },
  anchorNavigation: {
    borderBottomStyle: 'none',
    borderBottomColor: 'none',
    borderBottomWidth: 'none',
    boxShadow: `0px 0px 10px ${variables.colors.gray300}`,
  },
}
